export default __webpack_public_path__ + "static/media/凉凉.2eabb5a2.mp3";